<div class="side-nav-wrapper flex-area">
    @let isAdmin = user().isAdmin;

    <div class="side-nav-header flex-area">
        @if (platform.logo.endsWith(".svg")) {
            <img src="logos/lytehouse.svg" alt="Logo" class="logo-img">
        } @else {
            <img src="{{platform.logo}}" alt="Logo" class="logo-img">
        }
        <h1>{{platform.name}}</h1>
    </div>
    <div class="side-nav-content">
        <mat-nav-list class="side-nav-content">

            <!-- Quick Access -->
            <div mat-subheader class="nav-heading">Quick Access</div>
            @if (!(user().isVMSOnlyUser)) {
                <a mat-list-item routerLink="/alerts" (click)="navigate('alerts')" [activated]="activeRoute === '/alerts'">
                    <mat-icon>warning</mat-icon> Alert Dashboard
                </a>
                <a mat-list-item routerLink="/focus" (click)="navigate('focus')" [activated]="activeRoute === '/focus'">
                    <mat-icon>center_focus_strong</mat-icon> Focus Mode
                </a>
                <a mat-list-item routerLink="/sites" (click)="navigate('sites')" [activated]="activeRoute.includes('/sites')">
                    <mat-icon>location_on</mat-icon> Sites
                </a>
            }
            <a mat-list-item routerLink="/recordings" (click)="navigate('recordings')" [activated]="activeRoute === '/recordings'">
                <mat-icon>videocam</mat-icon> Recordings
            </a>
            <a mat-list-item routerLink="/vms" (click)="navigate('vms')" [activated]="activeRoute === '/vms'">
                <mat-icon>video_library</mat-icon> VMS
            </a>
            <a mat-list-item routerLink="/livefeed" (click)="navigate('livefeed')" [activated]="activeRoute === '/livefeed'">
                <mat-icon>live_tv</mat-icon> Live Feed
            </a>
            @if (isAdmin) {
                <a mat-list-item routerLink="/patrol-runs" (click)="navigate('patrol-runs')" [activated]="activeRoute === '/patrol-runs' || activeRoute.startsWith('/patrol-runs/')">
                    <mat-icon>fact_check</mat-icon> Scout Patrols
                </a>
                <a mat-list-item routerLink="/spotlyte" (click)="navigate('spotlyte')" [activated]="activeRoute === '/spotlyte' || activeRoute.startsWith('/spotlyte/jobs')">
                    <mat-icon>search</mat-icon> Spotlyte Jobs
                </a>
            }

            @if (isAdmin) {

                <!-- Reports -->
                <mat-divider class="nav-divider"></mat-divider>
                <div mat-subheader class="nav-heading nav-heading-toggle" role="button" tabindex="0" (click)="toggleSection('reports')" (keydown.enter)="toggleSection('reports')" (keydown.space)="$event.preventDefault(); toggleSection('reports')">
                    Reports
                    <mat-icon class="collapse-icon">{{isCollapsed('reports') ? 'chevron_right' : 'expand_more'}}</mat-icon>
                </div>
                @if (!isCollapsed('reports')) {
                    <a mat-list-item routerLink="/reports" (click)="navigate('reports')" [activated]="activeRoute === '/reports'">
                        <mat-icon>assessment</mat-icon> Reporting
                    </a>
                    <a mat-list-item permissions="VIEW_CAMERA" routerLink="/health" (click)="navigate('health')" [activated]="activeRoute === '/health'">
                        <mat-icon>monitor_heart</mat-icon> Health
                    </a>
                    @if (user().organisation_id === lytehouseOrgId) {
                        <a mat-list-item routerLink="/alert-report-templates" (click)="navigate('alert-report-templates')" [activated]="activeRoute === '/alert-report-templates'">
                            <mat-icon>summarize</mat-icon> Alert Report Templates
                        </a>
                    }
                }

                <!-- Configuration -->
                <mat-divider class="nav-divider"></mat-divider>
                <div mat-subheader class="nav-heading nav-heading-toggle" role="button" tabindex="0" (click)="toggleSection('configuration')" (keydown.enter)="toggleSection('configuration')" (keydown.space)="$event.preventDefault(); toggleSection('configuration')">
                    Configuration
                    <mat-icon class="collapse-icon">{{isCollapsed('configuration') ? 'chevron_right' : 'expand_more'}}</mat-icon>
                </div>
                @if (!isCollapsed('configuration')) {
                    <a mat-list-item routerLink="/recipients" (click)="navigate('recipients')" [activated]="activeRoute === '/recipients'">
                        <mat-icon>contacts</mat-icon> Contacts
                    </a>
                    <a mat-list-item routerLink="/tags" (click)="navigate('tags')" [activated]="activeRoute === '/tags'">
                        <mat-icon>label</mat-icon> Tags
                    </a>
                    <a mat-list-item routerLink="/rule-templates" (click)="navigate('rule-templates')" [activated]="activeRoute === '/rule-templates'">
                        <mat-icon>code</mat-icon> Rule Templates
                    </a>
                    <a mat-list-item routerLink="/devices" (click)="navigate('devices')" [activated]="activeRoute === '/devices'">
                        <mat-icon>devices</mat-icon> Devices
                    </a>
                    <lh-experimental-wrapper>
                        <a exp mat-list-item routerLink="/registries" (click)="navigate('registries')" [activated]="activeRoute === '/registries'">
                            <mat-icon>fingerprint</mat-icon> Identity Registries
                        </a>
                    </lh-experimental-wrapper>
                    <a mat-list-item routerLink="/patrol-templates" (click)="navigate('patrol-templates')" [activated]="activeRoute === '/patrol-templates'">
                        <mat-icon>shield</mat-icon> Scout Templates
                    </a>
                    <a mat-list-item routerLink="/patrol-schedules" (click)="navigate('patrol-schedules')" [activated]="activeRoute === '/patrol-schedules'">
                        <mat-icon>schedule</mat-icon> Scout Schedules
                    </a>
                    <a mat-list-item permissions="VIEW_RULE_SCHEDULE" routerLink="/rule-schedules" (click)="navigate('rule-schedules')" [activated]="activeRoute === '/rule-schedules'">
                        <mat-icon>rule</mat-icon> Rule Schedules
                    </a>
                }

                <!-- Accounts -->
                <mat-divider class="nav-divider"></mat-divider>
                <div mat-subheader class="nav-heading nav-heading-toggle" role="button" tabindex="0" (click)="toggleSection('accounts')" (keydown.enter)="toggleSection('accounts')" (keydown.space)="$event.preventDefault(); toggleSection('accounts')">
                    Accounts
                    <mat-icon class="collapse-icon">{{isCollapsed('accounts') ? 'chevron_right' : 'expand_more'}}</mat-icon>
                </div>
                @if (!isCollapsed('accounts')) {
                    <a mat-list-item routerLink="/users" (click)="navigate('users')" [activated]="activeRoute === '/users'">
                        <mat-icon>people</mat-icon> Users
                    </a>
                    @if (user().distribution !== null) {
                        <a mat-list-item routerLink="/customers" (click)="navigate('customers')" [activated]="activeRoute === '/customers'">
                            <mat-icon>business</mat-icon> Customers
                        </a>
                    }
                    <lh-experimental-wrapper>
                        <a exp mat-list-item routerLink="/subscriptions" (click)="navigate('subscriptions')" [activated]="activeRoute === '/subscriptions'">
                            <mat-icon>verified_user</mat-icon> Subscriptions (Legacy)
                        </a>
                        <a legacy mat-list-item routerLink="/subscriptions-plus" (click)="navigate('subscriptions-plus')" [activated]="activeRoute === '/subscriptions-plus'">
                            <mat-icon>verified_user</mat-icon> Subscriptions
                        </a>
                    </lh-experimental-wrapper>
                    <lh-experimental-wrapper>
                        <a exp mat-list-item routerLink="/feature-management" (click)="navigate('feature-management')" [activated]="activeRoute === '/feature-management'">
                            <mat-icon>bookmark_stacks</mat-icon> Feature Management
                        </a>
                    </lh-experimental-wrapper>
                }

            }
        </mat-nav-list>
    </div>
    <div class="side-nav-footer">
        @if (isAdmin) {
            <div class="admin-code-block">
                <p>Admin Code: {{code().code}}</p>
            </div>
        }
        <!-- Footer -->
    </div>

</div>
